import { render, staticRenderFns } from "./gsChengyuan.vue?vue&type=template&id=91b888ca&scoped=true&"
import script from "./gsChengyuan.vue?vue&type=script&lang=js&"
export * from "./gsChengyuan.vue?vue&type=script&lang=js&"
import style0 from "./gsChengyuan.vue?vue&type=style&index=0&id=91b888ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b888ca",
  null
  
)

export default component.exports